import React, { Fragment, useState, useContext } from "react"
import { Button, Menu, MenuItem, CircularProgress } from "@material-ui/core"
import ExpandMoreIcon from "@material-ui/icons/ExpandMore"
import { useDispatch } from "react-redux"
import styles from "./styles"
import { openSnackBar } from "../../../../../../actions/snack-bar"
import { toggleClickConfirmationDialog } from "../../../../../../actions/billingDialogs"
import { deleteSoloItem, duplicateSolo } from "../../../../../../actions/solos"
import SuperTableContext from "../../../../../../pages/Billing/SuperTableContext"
import { getSuperBillingTableData } from "../../../../../../actions/super"
import capitalizeFirstLetter from "../../../../../../utils/capitalizeFirstLetter"
import PropTypes from "prop-types"

function SuperAdminActionMenu({ data, history }) {
  const [loading, setLoading] = useState(false)
  const [anchorEl, setAnchorEl] = useState(null)

  const { tabValue, dateInfo, debouncedSearchValue, setTableData } = useContext(
    SuperTableContext
  )
  const dispatch = useDispatch()
  const classes = styles()

  const handleClick = event => {
    setAnchorEl(event.currentTarget)
  }

  const handleClose = () => {
    setAnchorEl(null)
  }

  const handleDelete = (tabValueFromSwitch, data) => {
    setLoading(true)
    dispatch(deleteSoloItem(tabValueFromSwitch, data))
      .then(() => {
        if (dateInfo && dateInfo.startDate && dateInfo.endDate) {
          dispatch(
            getSuperBillingTableData({
              type: tabValue,
              endDate: dateInfo && dateInfo.endDate,
              startDate: dateInfo && dateInfo.startDate,
              searchKey: debouncedSearchValue,
            })
          ).then(res => {
            setLoading(false)
            setTableData(res)
          })
        }
      })
      .catch(err => {
        console.log(err)
        dispatch(openSnackBar({ message: err.message }))
        setLoading(false)
        setTableData({})
      })
  }

  const openDeleteConfirmation = (aTab, itemData) => {
    let dataToDelete = {
      action: `delete this ${capitalizeFirstLetter(aTab)}`,
      confirmationFunc: handleDelete,
      funcArgs: [aTab, itemData.id],
    }
    dispatch(toggleClickConfirmationDialog(true, dataToDelete))
  }

  // Start Duplicate Solo
  const handleDuplicateSolo = () => {
    let type = tabValue.slice(0, -1)
    dispatch(duplicateSolo(type, data.id))
      .then(res => {
        history.push(`/billing/solo-${type}/${res.solo_id}`)
        dispatch(openSnackBar({ message: `Successfully duplicated ${type}` }))
      })
      .catch(err => {
        console.log(err)
        dispatch(openSnackBar({ message: "Error creating duplicate" }))
      })
  }

  const openDuplicateConfirmation = () => {
    let dupeData = {
      action: `duplicate this ${capitalizeFirstLetter(tabValue.slice(0, -1))}`,
      confirmationFunc: handleDuplicateSolo,
      funcArgs: [],
    }
    dispatch(toggleClickConfirmationDialog(true, dupeData))
  }
  // end Duplicate Solo

  const handleMenuItemClick = (event, index, id) => {
    // alert(`You clicked ${ actions[index]}{ data.id }`)
    // setSelectedIndex(index)
    // setAnchorEl(null)
    switch (actions[index]) {
      case "View":
        window.open(
          `/billing/solo-${tabValue === "invoices" ? "invoice" : "estimate"}/${
            data.id
          }/preview`,
          "_blank"
        )
        handleClose()
        break
      case "Edit":
        history.push(
          `/billing/solo-${tabValue === "invoices" ? "invoice" : "estimate"}/${
            data.id
          }`
        )
        handleClose()
        break
      case "Duplicate":
        openDuplicateConfirmation()
        handleClose()
        break
      case "Delete":
        openDeleteConfirmation(
          tabValue === "invoices" ? "invoice" : "estimate",
          data
        )
        handleClose()
        break
      default:
        return
    }
  }

  // prevent delete if a solo is attached to a shoot
  let actions = !data.shoot_id
    ? ["View", "Edit", "Duplicate", "Delete"]
    : ["View", "Edit", "Duplicate"]

  return (
    <Fragment>
      <Button
        disabled={loading}
        aria-controls="simple-menu"
        aria-haspopup="true"
        style={classes.buttonStyle}
        onClick={handleClick}
      >
        {loading ? <CircularProgress size={20} /> : "View"}
        <ExpandMoreIcon />
      </Button>
      <Menu
        id={data.id}
        anchorEl={anchorEl}
        // onChange={handleChange}
        style={classes.menuStyle}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
      >
        {actions.map((action, index) => {
          return (
            <MenuItem
              key={index}
              onClick={e => handleMenuItemClick(e, index, data.id)}
            >
              {action}
            </MenuItem>
          )
        })}
      </Menu>
    </Fragment>
  )
}
SuperAdminActionMenu.propTypes = {
  data: PropTypes.object,
  history: PropTypes.object,
}

export default SuperAdminActionMenu
